import { css } from '@emotion/css';

import { desktopDeviceMediaQuery } from 'helpers/media-queries';

export const hideForDesktopStyles = css`
  ${desktopDeviceMediaQuery} {
    display: none;
  }
`;
